export default "query getStoricoUpload ($numeroContratto: Int!) {\n    getStoricoUpload(numeroContratto: $numeroContratto)\n}";